import { Heading } from "@/design-system";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import type { SourcedFact } from "../types";
import { SourcedMetricGrid } from "./sourcedMetricGrid";

type MetricsSectionProps = {
  id: string;
  title: string;
  metrics: SourcedFact[];
};

export const MetricsSection = ({ id, title, metrics }: MetricsSectionProps) => (
  <PageSection labelledBy={`${id}-title`} className="flex flex-col gap-8">
    <Heading level={2} id={`${id}-title`}>
      {title}
    </Heading>
    <SourcedMetricGrid facts={metrics} />
  </PageSection>
);
